import { PricingEngineType } from '@/shared/generated'

import { normalizeTacticParams } from './helpers'

/**
 * Migrates the legacy rule-based params shape (`rule_id`) to the versioned one.
 * Only RB tactics carry a pricing rule — every other engine owns its own
 * `params` (MD periods, promo dates and target, …), so they must pass through
 * untouched or the campaign's settings are wiped on form reset.
 */
export const formatLegacyTactics = <T>(tactics: T): T => {
	const engine = (tactics as { engine?: string } | undefined)?.engine
	if (engine !== PricingEngineType.RB) return tactics

	const params = (tactics as { params?: unknown }).params

	return { ...tactics, params: normalizeTacticParams(params) }
}
